// extracted by mini-css-extract-plugin
module.exports = {"box":"breadCrumb_box__16zRS","item":"breadCrumb_item__2iVXo","active":"breadCrumb_active__1NvLG"};